export const enum NotificationKind {
    Error = 'error',
    Ok = 'ok',
}
